import axios from 'axios'
import { BASE_URL, CHECK_JIANSHU_LOGIN_URL, CHECK_LOGIN_URL, CONFIG_COIN_URL } from './config'
import { getToken } from '../services/authService'
import { waitForLoginGate } from './loginGate'

function getRequestPath (config) {
  var url = config.url || ''
  if (url.indexOf('http') === 0) {
    try {
      return new URL(url).pathname
    } catch (e) {
      return url.split('?')[0]
    }
  }
  return url.split('?')[0]
}

/** 登录探测链路上的请求必须放行，否则会与门闩死锁 */
function bypassesLoginGate (config) {
  var path = getRequestPath(config)
  return path === CHECK_JIANSHU_LOGIN_URL || path === CHECK_LOGIN_URL || path === CONFIG_COIN_URL
}

/**
 * 统一业务错误格式
 * @param {Object} data - 后端返回的 { code, message, ... }
 */
function normalizeBizError (data) {
  var code = data && data.code != null ? data.code : -1
  // 业务错误码映射，可按需扩展
  var msgMap = {
    102: '网络不给力,请重试',
    152: '未登录或登录已过期',
    151: '直接弹窗显示：该账号因违反平台公约已被封号，如需申诉请发邮件（help@jianshu.com）说明；'
  }
  var message = msgMap[code] || (data && (data.message || data.msg)) || '请求失败'
  var err = new Error(message)
  err.isApiError = true
  err.code = code
  err.message = message
  err.data = data
  return err
}

/**
 * 全局错误回调（可选）：在此处统一弹窗提示，避免每个接口单独写
 * 在 main.js 或 App.vue 中可覆盖：request.setErrorHandler(fn)
 */
var errorHandler = null
function setErrorHandler (fn) {
  errorHandler = fn
}

var request = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

request.interceptors.request.use(
  function (config) {
    var chain = Promise.resolve(config)
    if (!bypassesLoginGate(config)) {
      chain = chain.then(function () {
        return waitForLoginGate()
      }).then(function () {
        return config
      })
    }
    return chain.then(function (cfg) {
      var token = getToken()
      if (token) {
        cfg.headers.Authorization = 'Bearer ' + token
      }
      return cfg
    })
  },
  function (error) {
    return Promise.reject(error)
  }
)

// ------------------------- 响应拦截器 -------------------------
request.interceptors.response.use(
  function (response) {
    var data = response.data
    // 若后端统一使用 { code, message, data } 结构
    if (data && typeof data.code !== 'undefined') {
      var ok = data.code === 0 || data.code === 100 || data.code === '0' || data.code === '100'
      if (ok) {
        return data.data !== undefined ? data.data : data
      }
      var bizErr = normalizeBizError(data)
      if (errorHandler && (bizErr.code === 152 || bizErr.code === 151 || bizErr.code === 102)) errorHandler(bizErr)
      return Promise.reject(bizErr)
    }

    return data
  },
  function (error) {
    var err = error
    var data = err && err.response && err.response.data
    var code = data && data.code != null ? data.code : undefined

    // // 1. 业务错误码 152（未登录）
    // if (errorHandler && (code === 152 || code === '152')) {
    //   alert('登录状态异常，请重新登录')
    //   errorHandler(normalizeBizError(data))
    //   return Promise.reject(err)
    // }

    // 2. 网络层错误（超时、断网、HTTP 错误等）统一提示
    // 约定：HTTP 401 交给调用方处理，不触发全局弹窗/提示
    var httpStatus = err && err.response ? err.response.status : undefined
    if (errorHandler && httpStatus !== 401) {
      var message = '网络异常，请稍后重试'
      if (err.code === 'ECONNABORTED' || (err.message && err.message.indexOf('timeout') > -1)) {
        message = '请求超时，请检查网络后重试'
      } else if (err.message === 'Network Error') {
        message = '网络连接失败，请检查网络设置'
      } else if (err.response) {
        var status = err.response.status
        if (status === 404) {
          message = '请求的资源不存在'
        } else if (status === 500) {
          message = '服务器内部错误，请稍后重试'
        } else if (status === 502 || status === 503 || status === 504) {
          message = '服务暂时不可用，请稍后重试'
        }
      }
      var netErr = new Error(message)
      netErr.isNetworkError = true
      netErr.originalError = err
      errorHandler(netErr)
    }

    return Promise.reject(err)
  }
)

request.setErrorHandler = setErrorHandler
export default request
